import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { SelectItem, SelectItemGroup } from 'primeng/api';
import { ParticipantData, ParticipantFormComponent, ParticipantSetting } from '../../../../partials/participant-form/participant-form.component';

@Component({
  selector: 'app-orderform-participants',
  templateUrl: './orderform-participants.component.html',
  styleUrls: ['./orderform-participants.component.scss']
})
export class PlannerOrderformParticipantsComponent implements OnInit {

  @ViewChild('hiringmanager') hiringmanager: ParticipantFormComponent;
  @ViewChild('hr_businesspartner') hr_businesspartner: ParticipantFormComponent;
  @ViewChild('executive_contact') executive_contact: ParticipantFormComponent;
  @ViewChild('workers_council') workers_council: ParticipantFormComponent;
  @ViewChild('disabledpersons') disabledpersons: ParticipantFormComponent;

  @Input() form: UntypedFormGroup;
  @Input() options: { [key: string]: Array<SelectItem | SelectItemGroup> };
  @Input() texts: { [key: string]: string };
  @Input() user: ParticipantData;
  @Input() disabled = true;

  public visible = false;
  public settings: {[key: string]: ParticipantSetting} = {};

  private subForm: UntypedFormGroup = this.fb.group({});

  constructor(
    private fb: UntypedFormBuilder
  ) {
    this.initSettings();
  }

  ngOnInit(): void {
    this.form.addControl('participants', this.subForm);
  }

  public setSettings(templateSettings: any, crossSettings: any): void {
    this.initSettings();
    this.visible = false;
    if (crossSettings?.hiringmanager === true) {
      this.visible = true;
      this.settings.hiringmanager = {
        visible: true,
        required: true
      };
    }
    if (crossSettings?.hr_businesspartner === true) {
      this.visible = true;
      this.settings.hr_businesspartner = {
        visible: true
      };
    }
    if (crossSettings?.workers_council === true) {
      this.visible = true;
      this.settings.workers_council = {
        visible: true,
        required: true
      };
    }
    if (crossSettings?.executive_contact === 'on' || crossSettings?.executive_contact === 'required') {
      this.visible = true;
      this.settings.executive_contact = {
        visible: true,
        required: crossSettings?.executive_contact === 'required'
      };
    }
    if (crossSettings?.repr_disabled_persons === true) {
      this.visible = true;
      this.settings.disabled_persons_representative = {
        visible: true
      };
    }
  }

  public getPayload(): any {
    return {
      hiringmanager: this.hiringmanager?.getPayload() || null,
      hr_businesspartner: this.hr_businesspartner?.getPayload() || null,
      executive_contact: this.executive_contact?.getPayload() || null,
      workers_council: this.workers_council?.getPayload() || null,
      disabled_persons_representative: this.disabledpersons?.getPayload() || null,
    };
  }

  private initSettings(): void {
    this.settings = {
      hiringmanager: {
        visible: false,
        required: false
      },
      hr_businesspartner: {
        visible: false,
        required: false
      },
      executive_contact: {
        visible: false,
        required: false
      },
      workers_council: {
        visible: false,
        required: false
      },
      disabled_persons_representative: {
        visible: false,
        required: false
      },
    };
  }

}
